import type {RefObject} from 'react';
import {useEffect} from 'react';
import type {Editor} from 'grapesjs';
import {attachZoomGestures} from '@EmailMakerReact/lib/email-maker-zoom-gestures-library';

/**
 * Enables pinch-to-zoom on the canvas once the editor has finished loading — the GrapesJS
 * canvas document only exists after the `load` event, which `isEditorLoading` tracks.
 */
export function useEmailMakerZoomGestures(editor: Editor | null, isEditorLoading: boolean, canvasAreaRef: RefObject<HTMLDivElement | null>): void {
  useEffect(() => {
    const canvasArea = canvasAreaRef.current;
    if (!editor || isEditorLoading || !canvasArea) {
      return undefined;
    }
    return attachZoomGestures(editor, canvasArea);
  }, [editor, isEditorLoading, canvasAreaRef]);
}
